import React from 'react'
import { Outlet } from 'react-router-dom'
import { ApolloProvider } from '@apollo/client'
import { css, Global } from '@emotion/core'
import { node } from 'prop-types'

import { IntlProvider } from '@divvy-web/i18n'
import { ToastProvider } from '@divvy-web/skylab.toast'

import client from './apollo/ApolloClient'
import { AuthProvider } from './auth'
import PageErrorBoundary from './components/PageErrorBoundary'
import Root from './components/Root'
import ThemeProvider from './components/theme-provider'
import { WebTrackingProvider } from './tracking/WebTrackingContext'

const GlobalToastStyle = () => <Global styles={globalToastStyle} />

const globalToastStyle = ({ mq }) => css`
  // The value of z-index for the toast is required to be this high
  // because it needs to supersede the z-index value of intercom launcher button
  // which is > 2100000000

  .Toast {
    ${mq.xxSmallMaxWidth({ zIndex: '2500000000 !important' })}
  }

  .Toast-container {
    ${mq.xxSmallMaxWidth({
      padding: 'var(--tri-space-150) var(--tri-space-300) !important',
      width: '90% !important',
    })}
  }

  .Toast-msg {
    ${mq.xxSmallMaxWidth({ fontSize: '4vw', overflowWrap: 'anywhere' })}
  }
`

const AppProvider = () => {
  return (
    <ApolloProvider client={client}>
      <AuthProvider>
        <ThemeProvider>
          <IntlProvider
            locale='en'
            textComponent='span'
          >
            <WebTrackingProvider>
              <GlobalToastStyle />
              <ToastProvider>
                <Root>
                  <PageErrorBoundary>
                    <Outlet />
                  </PageErrorBoundary>
                </Root>
              </ToastProvider>
            </WebTrackingProvider>
          </IntlProvider>
        </ThemeProvider>
      </AuthProvider>
    </ApolloProvider>
  )
}

AppProvider.propTypes = {
  children: node,
}

export default AppProvider
